import React from "react";

export default function NowPlayingBadge({ count, className = "" }) {
  if (!count || count < 1) return null;
  return (
    <span data-testid="now-playing-badge" className={`inline-flex items-center gap-1.5 text-[10px] font-mono-nu font-semibold text-emerald-400 ${className}`}>
      <span className="relative flex h-2 w-2">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
        <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500" />
      </span>
      {count} listening
    </span>
  );
}
